type TPagination = {
    totalCount: number;
    itemsPerPage: number;
    currentPage: number;
    refObject?: React.RefObject<any>;
    onPageChange: (page: number) => void;
};

export const Pagination = (props: TPagination) => {
    const { totalCount, itemsPerPage, currentPage, refObject } = props;

    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const htmlElementRef = refObject?.current;

    const handleClick = (page: number) => {
        props.onPageChange(page - 1);
        htmlElementRef?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
    };

    const PageButton = ({ pageNumber }: { pageNumber: number }) => (
        <li
            key={pageNumber}
            className={`page-item ${
                currentPage === pageNumber ? "active" : ""
            }`}
        >
            <button
                className="page-link"
                onClick={() => handleClick(pageNumber)}
            >
                {pageNumber}
            </button>
        </li>
    );

    const DottedButton = () => {
        return (
            <li className="page-item ">
                <span className="page-link">...</span>
            </li>
        );
    };

    const renderPaginationButtons = () => {
        const buttons = [];

        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                buttons.push(<PageButton key={i} pageNumber={i} />);
            }
        } else {
            if (currentPage + 1 <= 10) {
                for (let i = 1; i <= 10; i++) {
                    buttons.push(<PageButton key={i} pageNumber={i} />);
                }
                buttons.push(<DottedButton />);
            } else if (currentPage + 1 > totalPages - 9) {
                buttons.push(<DottedButton />);
                for (let i = totalPages - 9; i <= totalPages; i++) {
                    buttons.push(<PageButton key={i} pageNumber={i} />);
                }
            } else {
                buttons.push(<PageButton key={1} pageNumber={1} />);

                buttons.push(<DottedButton />);

                const start = Math.max(currentPage + 1 - 3, 2);
                const end = Math.min(currentPage + 1 + 2, totalPages - 1);

                for (let i = start; i <= end; i++) {
                    buttons.push(<PageButton key={i} pageNumber={i} />);
                }

                buttons.push(<DottedButton />);

                buttons.push(
                    <PageButton key={totalPages} pageNumber={totalPages} />
                );
            }
        }

        return buttons;
    };

    return (
        <>
            <ul className="pagination justify-content-center">
                <li
                    className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                    }`}
                >
                    <button
                        className="page-link"
                        aria-label="Previous"
                        onClick={() => handleClick(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        <span aria-hidden="true">&laquo;</span>
                    </button>
                </li>
                {renderPaginationButtons()}
                <li
                    className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                    <button
                        className="page-link"
                        aria-label="Next"
                        onClick={() => handleClick(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        <span aria-hidden="true">&raquo;</span>
                    </button>
                </li>
            </ul>
        </>
    );
};
